<template>
  <div>
    <b-form-group :label="label">
      <b-form-textarea @change="$emit('input', $event)" :value="value"></b-form-textarea>
      <small v-if="desc">{{ desc }}</small>
    </b-form-group>
  </div>
</template>

<script>
export default {
  props: ['value', 'label', 'desc']
}
</script>
